import { setAllowedFormats } from './TagsTransformers'

export const mergeTagsList = [
  {
    title: 'Información personal',
    menu: [
      {
        title: 'Código de empleado',
        menu: setAllowedFormats(
          'Código de empleado',
          'employee.code',
          'STRING'
        ),
      },
      {
        title: 'Nombre Completo',
        menu: setAllowedFormats('Nombre Completo', 'employee.name', 'STRING'),
      },
      {
        title: 'Primer Nombre',
        menu: setAllowedFormats(
          'Primer Nombre',
          'employee.firstName',
          'STRING'
        ),
      },
      {
        title: 'Segundo Nombre',
        menu: setAllowedFormats(
          'Segundo Nombre',
          'employee.secondName',
          'STRING'
        ),
      },
      {
        title: 'Apellido Paterno',
        menu: setAllowedFormats(
          'Apellido Paterno',
          'employee.lastName',
          'STRING'
        ),
      },
      {
        title: 'Apellido Materno',
        menu: setAllowedFormats(
          'Apellido Materno',
          'employee.secondLastName',
          'STRING'
        ),
      },
      {
        title: 'Tipo de identificación',
        menu: setAllowedFormats(
          'Tipo de identificación',
          'employee.identificationType',
          'STRING'
        ),
      },
      {
        title: 'Numero de identificación',
        menu: [
          {
            title: 'Numero de identificación - Sin formato',
            value: 'employee.identificationNumber',
          },
          {
            title:
              'Numero de identificación - ej. TRES MILLONES CON VEINTIOCHO',
            value: 'employee.identificationNumber|identificationToText',
          },
        ],
      },
      {
        title: 'Genero',
        menu: setAllowedFormats('Genero', 'employee.gender', 'STRING'),
      },
      {
        title: 'Fecha de cumpleaños',
        menu: setAllowedFormats(
          'Fecha de cumpleaños',
          'employee.birthDate',
          'DATE'
        ),
      },
      {
        title: 'Nacionalidad',
        menu: setAllowedFormats(
          'Nacionalidad',
          'employee.nationality',
          'STRING'
        ),
      },
    ],
  },
  {
    title: 'Información de contacto',
    menu: [
      {
        title: 'Correo Electrónico',
        menu: setAllowedFormats(
          'Correo Electrónico',
          'employee.email',
          'STRING'
        ),
      },
      {
        title: 'Dirección fisica',
        menu: setAllowedFormats(
          'Dirección fisica',
          'employee.addressLocation',
          'STRING'
        ),
      },
      {
        title: 'País de residencia',
        menu: setAllowedFormats(
          'País de residencia',
          'employee.countryResidence',
          'STRING'
        ),
      },
      {
        title: 'Ciudad de residencia',
        menu: setAllowedFormats(
          'Ciudad de residencia',
          'employee.cityResidence',
          'STRING'
        ),
      },
      { title: 'Teléfono principal', value: 'employee.primaryPhone' },
      {
        title: 'Teléfono secundario',
        value: 'employee.secondaryPhone',
        notInclude: ['4'],
      }, //NOT DESIGNER
      {
        title: 'Código postal',
        value: 'employee.postalCode',
        notInclude: ['4'],
      }, //NOT DESIGNER
    ],
  },
  {
    title: 'Información Organizacional',
    menu: [
      {
        title: 'Posición o Cargo',
        menu: setAllowedFormats(
          'Posición o Cargo',
          'employee.position',
          'STRING'
        ),
      },
      {
        title: 'Tipo de contrato',
        menu: setAllowedFormats(
          'Tipo de contrato',
          'employee.contractType',
          'STRING'
        ),
      },
      {
        title: 'Sucursal',
        menu: setAllowedFormats('Sucursal', 'employee.subsidiary', 'STRING'),
      },
      {
        title: 'Dirección',
        menu: setAllowedFormats('Dirección', 'employee.direction', 'STRING'),
      },
      {
        title: 'Gerencia',
        menu: setAllowedFormats('Gerencia', 'employee.management', 'STRING'),
      },
      {
        title: 'Departamento',
        menu: setAllowedFormats(
          'Departamento',
          'employee.department',
          'STRING'
        ),
      },
      {
        title: 'Area',
        menu: setAllowedFormats('Area', 'employee.area', 'STRING'),
      },
    ],
  },
  {
    title: 'Información Laboral',
    menu: [
      {
        title: 'Fecha de ingreso',
        menu: setAllowedFormats(
          'Fecha de ingreso',
          'employee.joiningDate',
          'DATE'
        ),
      },
      {
        title: 'Fecha de salida',
        menu: setAllowedFormats(
          'Fecha de salida',
          'employee.leavingDate',
          'DATE'
        ),
      },
      {
        title: 'Motivo de salida',
        menu: setAllowedFormats(
          'Motivo de salida',
          'employee.leaveReason',
          'STRING'
        ),
      },
      {
        title: 'Monto del salario base',
        menu: setAllowedFormats(
          'Monto del salario base',
          'employee.salaryAmount',
          'MONEY'
        ),
      },
      { title: 'Moneda del salario base', value: 'employee.currency' },
      {
        title: 'Tipo de salario',
        menu: setAllowedFormats(
          'Tipo de salario',
          'employee.salaryType',
          'STRING'
        ),
      },
      {
        title: 'Saldo de vacaciones',
        menu: [
          {
            title: 'Saldo de vacaciones - Sin_formato',
            value: 'employee.vacationBalance',
          },
          {
            title: 'Saldo de vacaciones - 0,0.00',
            value: 'employee.vacationBalance|0,0.00',
          },
          {
            title: 'Saldo de vacaciones - 0.0,00',
            value: 'employee.vacationBalance|0.0,00',
          },
        ],
      },
    ],
  },
  {
    title: 'Información auxiliar',
    menu: [
      {
        title: 'Fecha actual',
        menu: setAllowedFormats('Fecha actual', 'currentDate', 'DATE'),
      },
      {
        title: 'Año actual',
        value: 'currentYear',
      },
      {
        title: 'Mes actual',
        menu: setAllowedFormats('Mes actual', 'currentMonth', 'STRING'),
      },
    ],
  },
  {
    title: 'Información de la ultima nómina',
    menu: [
      {
        title: 'Año de la úiltima nómina',
        value: 'lastPayroll.year',
      },
      {
        title: 'Mes de la úiltima nómina',
        menu: setAllowedFormats(
          'Mes de la úiltima nómina',
          'lastPayroll.month',
          'STRING'
        ),
      },
      {
        title: 'Fecha de inicio',
        menu: setAllowedFormats(
          'Fecha de inicio',
          'lastPayroll.dateInit',
          'DATE'
        ),
      },
      {
        title: 'Fecha final',
        menu: setAllowedFormats('Fecha final', 'lastPayroll.dateEnd', 'DATE'),
      },
      {
        title: 'Rango de fechas',
        value: 'lastPayroll.lastPeriodDateRange',
      },
      {
        title: 'numero de periodo de la última nómina',
        value: 'lastPayroll.period',
      },
      {
        title: 'Monto total de un concepto',
        menu: setAllowedFormats(
          'Monto del concepto de la última nómina completa',
          'lastPayroll.concept{{code}}.amount',
          'MONEY'
        ),
      },
      {
        title: 'Monto total de asignaciones',
        menu: setAllowedFormats(
          'Monto total de asignaciones',
          'lastPayroll.concept9999-1.amount',
          'MONEY'
        ),
      },
      {
        title: 'Monto total de deducciones',
        menu: setAllowedFormats(
          'Monto total de deducciones',
          'lastPayroll.concept29999-1.amount',
          'MONEY'
        ),
      },
      {
        title: 'Monto neto a pagar',
        menu: setAllowedFormats(
          'Monto neto a pagar',
          'lastPayroll.concept39999-1.amount',
          'MONEY'
        ),
        notInclude: ['1', '4'], //APS, DESIGNER
      },
      {
        title: 'Lista de asignaciones',
        value: 'lastPayroll.earningsDetails',
      },
      {
        title: 'Lista de deducciones',
        value: 'lastPayroll.deductionsDetails',
      },
    ],
  },
]
